import React from 'react';

import withIntl from '../../shared/intl-hoc';

import { ranks } from '../../../../../enums/affiliate-ranks';

function RankInfo({ intl, rank, gift }) {
	return (
		<div className='rank-info'>
			<div className='rank-info-status'>
				<div className='rank-info-status-image'>
					<img src={rank.status.image} alt='rank status image' />
				</div>
				<div className='rank-info-status-title font-museo-sans-medium'>
					{rank.status.title}
				</div>
			</div>
			<div className='rank-info-description'>
				{rank.description}
			</div>
			{gift ? (
				<div className='rank-info-gift'>
					<div className='rank-info-gift-image'>
						<img src={gift.image} alt='rank gift image' />
					</div>
					<div className='rank-info-gift-title font-museo-sans-medium'>
						{gift.title}
					</div>
				</div>
			) : rank.id !== ranks.beginner && (
				<div className='rank-info-gift-received'>
					{intl('Получено')}
				</div>
			)}
		</div>
	);
}

export default withIntl(RankInfo);


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/ranks/components/rank-info.js